//Hình thức thu của QLTH (1: Tiền mặt 2: Tiền gửi)
export default {
  CAReceiptVoucher: 1, // Hình thức thu tiền mặt
  BADepositVoucher: 2, // Hình thức thu tiền gửi
};
